<template>
  <el-dropdown :popper-class="isblack?'dark-dropdown':''" trigger="click" @command="handleLanguageChange">
    <div class="lang-select--style">
      <svg-icon v-if="!isblack" icon-class="language" style="color: #FFF;" />
      <img v-else src="/src/assets/images/language.png" style="width: 32px;height: 32px;" />
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item v-for="item in list" :disabled="appStore.language === item.value" :command="item.value"> {{item.name}} </el-dropdown-item>
        <!-- <el-dropdown-item :disabled="appStore.language === 'zh_CN'" command="zh_CN"> 中文 </el-dropdown-item>
        <el-dropdown-item :disabled="appStore.language === 'en_US'" command="en_US"> English </el-dropdown-item> -->
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup lang="ts">
import '@/assets/styles/dark.scss'
import { useI18n } from 'vue-i18n';
import { useAppStore } from '@/store/modules/app';
import SvgIcon from '@/components/SvgIcon/index.vue';
const props = defineProps({
  imgSrc: { type: String, default: '' },
  isblack: { type: Boolean, default: false }
})
const list = ref(window.LANGUAGE_LIST)
const appStore = useAppStore();
const { t, locale } = useI18n();

const handleLanguageChange = (lang: any) => {
  locale.value = lang;
  appStore.changeLanguage(lang);
  // 先切换 locale 再提示，保证提示文案展示为目标语言。
  ElMessage.success(t('basicComponents.languageSwitchSuccess'));
  location.reload();
};
</script>

<style lang="scss" scoped>
.lang-select--style {
  font-size: 18px;
  line-height: 50px;
}
</style>

